export class LazyInitializer {
    get value() {
        this.init();
        return this._value;
    }
    constructor(factory) {
        this.factory = factory;
    }
    init() {
        if (this._value !== undefined)
            return;
        this._value = this.factory();
    }
}
export const lazy = (factory) => new LazyInitializer(factory);
//# sourceMappingURL=lazy-initializer.js.map